import styled from 'styled-components';
import { device } from '../../styles/devices';

/**
 * Layout
 */
export const Wrapper = styled.div`
  display: flex;
  padding: 10px;
  gap: 48px;
  flex-wrap: wrap;
  padding-bottom: 32px;
  align-items: center;
  @media ${device.tablet} {
    padding: 60px 0 32px 32px;
    align-items: center;
  }
  @media ${device.laptop} {
    padding: 60px 0 32px 0;
    align-items: center;
    justify-content: center;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  font-family: 'Audi Type';
  @media ${device.tablet} {
    flex-grow: 0;
    min-width: 768px;
  }
`;

/**
 * Body
 */
export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Copy = styled.p`
  display: inline-block;
  font-size: 16px;
  line-height: 24px;
  padding: 10px 0;
`;

// Wrappers are separated from text to allow for proper borders
export const SpecWrapper = styled.div`
  display: block;
  min-width: 220px;
  margin-right: 10px;
  border-top: 2px solid black;
`;

export const Spec = styled(Copy)`
  margin: 0 50px 20px 0;
  min-width: 120px;
  font-weight: bold;
  @media ${device.tablet} {
    min-width: 220px;
  }
`;

export const SpecBodyWrapper = styled.div`
  flex-grow: 1;
  border-top: 1px solid #4c4c4c;
  max-width: 50%;
  @media ${device.laptop} {
    max-width: 80%;
  }
`;

export const SpecBody = styled(Copy)`
  flex-grow: 1;
`;
